import React from 'react'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'
import classnames from 'classnames'

import { ReactComponent as Pencil } from '../../../../../assets/icons/pencil.svg'
import { ReactComponent as Minimize } from '../../../../../assets/icons/minimize.svg'

import useDrawerFormStyles from '../../../../../styles/common/drawerForms'

// this component allows to control visibility by Preview and edit Form/Fields
const EditSection = ({ title, children, isSectionOpen, toggleSectionVisibility, preview }) => {
  const { t } = useTranslation()

  const drawerFormClasses = useDrawerFormStyles()

  return (
    <section className={drawerFormClasses.section}>
      <h3 className={classnames(drawerFormClasses.sectionTitle, drawerFormClasses.previewSectionTitle)}>{t(title)}</h3>
      {/* to avoid unnecessary endpoints call, and also for a better performance - SectionForm within the formik and
       other logic is only renders and invokes when it's opened */}
      {isSectionOpen ? (
        <>
          <Minimize className={drawerFormClasses.sectionIcon} onClick={toggleSectionVisibility} />
          {children}
        </>
      ) : (
        <>
          <Pencil className={drawerFormClasses.sectionIcon} onClick={toggleSectionVisibility} />
          <div className={drawerFormClasses.sectionPreview}>{preview}</div>
        </>
      )}
    </section>
  )
}

EditSection.propTypes = {
  title: PropTypes.string,
  children: PropTypes.node.isRequired,
  isSectionOpen: PropTypes.bool.isRequired,
  toggleSectionVisibility: PropTypes.func.isRequired,
  preview: PropTypes.node
}

export default EditSection
